type UseChartFontScaleOptions = {
	referenceWidth?: number;
	minScale?: number;
};

const DEFAULT_REFERENCE_WIDTH = 360;
const DEFAULT_MIN_SCALE = 0.7;

export const useChartFontScale = (
	containerWidth: number,
	options?: UseChartFontScaleOptions,
): number => {
	const referenceWidth = options?.referenceWidth ?? DEFAULT_REFERENCE_WIDTH;
	const minScale = options?.minScale ?? DEFAULT_MIN_SCALE;

	return Math.max(minScale, Math.min(1, containerWidth / referenceWidth));
};
